// extracted by mini-css-extract-plugin
export default {"toggleButton":"ThemeToggle_toggleButton__DN95W","light":"ThemeToggle_light__5cIDS","dark":"ThemeToggle_dark__3WKYD"};